<template>
  <div>
    <v-row>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        class="pb-4 pt-0 mt-0"
        @click.stop
      />
      <v-data-table
        id="filterSessionTable"
        v-model="selectedFilters"
        :search="search"
        :items="tableItems"
        :hide-default-footer="true"
        :hide-default-header="true"
        :items-per-page="-1"
        item-key="value"
        :headers="headers"
        :height="!expandList ? 250 : tableItems.length * 48"
        show-select
        :custom-filter="filterDataTableSession"
        checkbox-color="third"
        @click:row="rowClick"
        @input="updateFilterField()"
      >
        <template #item.name="{ item }">
          {{ item.label }}
        </template>
        <template #item.count="{ item }">
          <v-avatar color="third" size="24">
            <span class="white--text">{{ item.count || 0 }}</span>
          </v-avatar>
        </template>
      </v-data-table>
      <div v-if="items.length > 5">
        <span class="font-weight-bold pointer" @click="expandList = !expandList">{{
          !expandList ? "Voir tous" : "Voir moins"
        }}</span>
      </div>
    </v-row>
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api';
import store from '@/store';

export default {
  props: {
    items: {
      type: Array,
      default: null
    },
    filter: {
      type: Object,
      default: null
    },
    value: {
      type: Array,
      default: null
    },
    updateFilter: { type: Function, default: null },
    reference: {
      type: String,
      default: null
    }
  },
  setup (props) {
    const search = ref(null);
    const expandList = ref(false);
    const selectedFilters = ref([]);

    const sideBarFilters = computed(() => store.getters.sideBarFilters);

    watch(selectedFilters, () => {
      if (props.filter.type === 'session') {
        store.commit('setIsSessionFilterApplied', !!selectedFilters.value.length);
      }

      const toStore = { ...sideBarFilters.value };

      if (!toStore[props.filter.contentType]) {
        toStore[props.filter.contentType] = {};
      }
      if (!toStore[props.filter.contentType][props.filter.field]) {
        toStore[props.filter.contentType][props.filter.field] = [];
      }

      if (props.filter.subfield) {
        if (!toStore[props.filter.contentType][props.filter.field][props.filter.subfield]) {
          toStore[props.filter.contentType][props.filter.field][props.filter.subfield] = [];
        }
        if (selectedFilters.value.map(v => v.value).length) {
          toStore[props.filter.contentType][props.filter.field][props.filter.subfield] = selectedFilters.value.map(v => v.value);
        } else {
          toStore[props.filter.contentType][props.filter.field] = {};
        }
      } else {
        toStore[props.filter.contentType][props.filter.field] = selectedFilters.value.map(v => v.value);
      }

      store.commit('setSideBarFilters', toStore);
    });

    watch(() => props.value, () => {
      selectedFilters.value = props.value;
    });

    const filterDataTableSession = (value, searchValue, item) => item.label.toLowerCase().includes(searchValue.toLowerCase());

    const manageListItem = computed(() => (expandList.value ? 9999999 : 5));

    const tableItems = computed(() => props.items.slice(0, manageListItem.value));

    const rowClick = (item, row) => {
      row.select(!row.isSelected);
    };

    const headers = [
      { text: '', value: 'name' },
      { text: '', value: 'count' }
    ];

    const updateFilterField = () => {
      selectedFilters.value.map(filter => {
        filter.reference = props.reference;
        return filter;
      });
      props.updateFilter();
    };

    return {
      search,
      selectedFilters,
      filterDataTableSession,
      expandList,
      tableItems,
      rowClick,
      headers,
      updateFilterField
    };
  }
};
</script>

<style>
#filterSessionTable > div > table {
  table-layout: auto;
}

#filterSessionTable {
  width: 300px;
}

#filterSessionTable tr {
  cursor: pointer;
}
</style>
